// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__HE9e-","inputWrap":"CustomTip_inputWrap__369SO"};